import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { translate } from 'translations/i18n';

import { tokens } from '@companycam/slab';
import { Text, Link, InputCheckbox } from '@companycam/slab-web';

// #region styled-components
const StyledLabel = styled.label`
  display: flex;
  align-items: center;
  font-size: 12px;
`;

const AcceptView = styled.div`
  margin: 32px 0px;
`;

const TermsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${tokens.size_spacing_xs}px;
`;
// #endregion

const TermsDescription = (
  <TermsContainer>
    <Text as="p">{translate('legal.agreeTo')}</Text>
    <Link href="https://www.companycam.com/terms" target="blank">
      {translate('legal.termsOfService')}
    </Link>
    <Text as="p">{translate('common.and')}</Text>
    <Link href="https://www.companycam.com/privacy-policy" target="blank">
      {translate('legal.privacyPolicy')}
    </Link>
  </TermsContainer>
);

const AcceptTosCheckbox = ({ checked, onClickCheckbox }) => {
  return (
    <AcceptView>
      <StyledLabel>
        <InputCheckbox
          label={TermsDescription}
          id="signup__accepted-tos"
          checked={checked}
          testId="signup__accepted-tos"
          data-testid="signup__accepted-tos"
          onChange={onClickCheckbox}
          onKeyDown={(e) => e.keyCode === 13 && onClickCheckbox()}
        />
      </StyledLabel>
    </AcceptView>
  );
};

export default AcceptTosCheckbox;

AcceptTosCheckbox.propTypes = {
  checked: PropTypes.bool,
  onClickCheckbox: PropTypes.func,
};
